'use client';

import { useOverlay } from '@flipster/overlay';
import { Button } from '@flipster/react/design-system';
import { IconButton } from '@flipster/react/design-system/icon-button';
import QrCodeIcon from '@flipster/react/icon/generated/QrCodeIcon';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

import { AppDownloadModal } from '@web/app/[locale]/_app-download/modal';

const isFlipsterMe = (process.env.NEXT_PUBLIC_SERVER_URL ?? '').includes('flipster.me');

export const DownloadAppButton = () => {
  const overlay = useOverlay();

  const onClickDownloadApp = () => {
    segment.track(MainEvent.MainPageDownloadAppClick);
    const params = new URLSearchParams(window.location.search);
    const isExistQueryString = params.get('apk');
    overlay.open(<AppDownloadModal isShowAPK={!!(isFlipsterMe || isExistQueryString)} />);
  };

  return (
    <>
      {/* > mobile */}
      <div
        className={hstack({
          display: { base: 'none', tablet: 'flex' },
          textStyle: 'Text/M/Strong',
          color: 'content.default.level-2',
          gap: 8,
        })}
      >
        <p>Download app</p>
        <IconButton
          hierarchy='tertiary'
          size='large'
          icon={<QrCodeIcon color={token('colors.content.default.level-4')} />}
          onClick={onClickDownloadApp}
        />
      </div>
      {/* = mobile */}
      <Button
        hierarchy='secondary'
        color='neutral'
        size='large'
        label='Download app'
        onClick={onClickDownloadApp}
        css={{ display: { tablet: 'none' }, w: '100%' }}
      />
    </>
  );
};
